<!--  -->
<template>
  <div>
    <section class="page-banner" style="background-image: url(/static/img/gerenxinxi.png);">
      <div class="container">
          <div class="banner-tip">
              <h2 class="banner-title">个人信息</h2>
              <div class="bread-crumbs">
                informations
              </div>
          </div>
      </div>
    </section>  
    <section class="admission-area">
        <div class="w3layoutscontaineragileits">
            <h2 class="title-ch">关于我</h2>
            <div class="title-en">ABOU ME</div>
            <div>
                <div class="row detail-info">
                    <div class="form-group">
                        <label class="form-label">个人姓名</label>
                        <input class="form-control" type="text" v-model="user.name" placeholder="你的姓名" disabled>
                    </div>
                    <!-- <div class="col-lg-4 form-group">
                        <label class="form-label">性别</label>
                            <div class="course-filter">
                            <div class="courses-ordering">
                            <select class="target-course" v-model="user.sex">
                                <option value="男">男</option>
                                <option value="女">女</option>
                            </select>
                            </div>
                            </div>
                    </div>
                    <div class="col-lg-4 form-group">
                        <label class="form-label">身份证号码</label>
                        <input class="form-control" type="text" v-model="user.identificationcard" placeholder="身份证号码" disabled>
                    </div>
                    <div class="col-lg-4 form-group">
                        <label class="form-label">出生年月</label>
                        <div class="course-filter ">
                                <el-date-picker
                                v-model="user.birthday"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </div>
                    </div> -->
                    <div class="form-group">
                        <label class="form-label">个人邮箱</label>
                        <input class="form-control" type="email"  v-model="user.email" placeholder="你的邮箱">
                    </div>
                        <div class="form-group">
                        <label class="form-label">所学科目</label>
                        <div class="course-filter">
                            <div class="courses-ordering">
                                <el-tag
                                    style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #000000;border:0;"
                                    v-for="tag in paperSubs"
                                    :key="tag"
                                    >
                                    {{tag}}
                                </el-tag>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                    </div><!-- end col-lg-6 -->
                        <div class="col-lg-6">
                        
                    </div><!-- end col-md-12 -->
                </div><!-- end row -->
                <div class="aitssendbuttonw3ls">
                    <input type="submit" @click="updateInfo()" value="提交修改">
                    <button class="theme-btn" @click="visibleChgPwd = true;">修改密码</button>
                </div>
            </div>
        </div>
    </section><!-- end admission-area -->
     <section class="admission-area">
      <div class="container genreninfo">
        <h2 class="title-ch">个人数据</h2>
        <div class="contact">
          <div class="single xuexi">
            <div>
              <h5>学习时长：</h5>
              <span>{{ user.studyhours }}</span>
            </div>
          </div>
          <div class="single kecc">
            <div>
              <h5>课程：</h5>
              <span>{{ paperSubs[0] }}</span>
            </div>
          </div>
            <div class="single shuju">
              <div>
                <h5>正确率：</h5>
                <span>{{ getshuju }}</span>
              </div>
            </div>
              <div class="single time-line">
              <div>
                <h5>常在线时间：</h5>
                <span>上午</span>
              </div>
            </div>
      </div>
      </div>
     </section>
    <el-dialog
        title="输入新密码"
        :visible.sync="visibleChgPwd"
        width="30%"
        center>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="currentPassword">
                <el-input  type="password" v-model="ruleForm.currentPassword"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="newPassword">
                <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="chgPassword('ruleForm')">提交</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
        </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
export default {
  data () {
    var checkAge = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('请输入原密码'));
        }else{
            callback();
        }
    };
    var validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入新密码'));
        } else {
            if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
        }
    };
    var validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请再次输入密码'));
    } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
    };
    return {
        user:{
           
        },
        paperSubs:[],
         visibleChgPwd:false,
        ruleForm: {
          newPassword: '',
          checkPass: '',
          currentPassword: ''
        },
        rules: {
          newPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          password: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
    };
  },

  components: {},

  computed: {
    getshuju() {
      return (1 - (this.user.error / this.user.correct)).toFixed(2) * 100 + "%";
    }
  },

  mounted(){
      this.$axios.get("/api/auth/me").then(res => {
          this.user = res.data.data;
            let arrhasCourse = [];
            for (var i = 0; i <res.data.data.needexaminee.length; i++)
            {
                arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
            }
            this.paperSubs = arrhasCourse;
        })
  },

  methods: {
      updateInfo(){
          this.$axios.put("/api/auth/updatedetails", this.user).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
          })
      },
      chgPassword(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //alert('submit!');
            this.$axios.put("/api/auth/updatePassword", this.ruleForm).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
                this.visibleChgPwd = false;
            })
          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
  }
}

</script>
<style scoped>

.w3layoutscontaineragileits{
  position: relative;
  width: 1200px;
  height: auto;
  margin:73px auto 20px;
  overflow: hidden;
}
.title-ch{
height: 32px;
font-size: 32px;
font-family: PingFang SC;
font-weight: bold;
color: #252626;
line-height: 32px;
text-align: center;
}
.title-en{
margin-top: 24px;
height: 16px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #949699;
line-height: 16px;
text-align: center;
}

.form-control,.course-filter{
  width: 350px;
height: 54px;
background: #F2F4F9;
border-radius: 5px;
  border: 0;
}
.course-filter{
opacity: 0.79;
border: 1px solid #4462CF;
}
.courses-ordering{
  margin-top: 10px;
}
/deep/ .el-input--prefix .el-input__inner{
      width: 100%;
  height: 52px;
  background: #FFFFFF;
  border: 1px solid #4282CA;
  opacity: 0.75;
  border-radius: 3px;
  /* margin: 48px auto; */
    display: block;
}
.target-course{
    width: 100%;
  height: 52px;
  background: #FFFFFF;
  border: 1px solid #4282CA;
  opacity: 0.75;
  border-radius: 3px;
  /* margin: 48px auto; */
    display: block;
}
.agiletext{
  width: 111px;
  height: 14px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #636A76;
  line-height: 43px;
}
.agileinfotickwthree{
  position: relative;
  margin-left: 56px;
}
.aitssendbuttonw3ls{
  text-align:right;
}
.aitssendbuttonw3ls input,.theme-btn{
  padding-right: 0;
  margin: 37px 12px 0;
width: 162px;
height: 60px;
background: #F55C57;
border-radius: 5px;
border: 0;
font-size: 22px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 60px;
}
.theme-btn{
  margin-right: 0;
  background: #3AB199;
}
.img-edge-cover {
  position:absolute;
  width: 253px;
       top: 368px;
}
.img-edge-cover img{
    width: 253px;
    display: block;
    margin-bottom: 20px;
        opacity: 0.7;
}
.form-label{
  padding-left: 9px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 400;
color: #666666;
line-height: 18px;
margin-bottom: 20px;
}
.form-group{ 
  margin-bottom: 0;
}
.detail-info{
   margin-top: 55px;     
       padding-left: 15px;
    padding-right: 15px;
}
.form-group:nth-child(1){
  margin-right: 75px;
}
.form-group:nth-child(2){
margin-right: 75px;
}
.genreninfo{
  margin-top: 55px;
  width: 1200px;
height: 218px;
background: #FFFFFF;
box-shadow: 0px 6px 29px 0px rgba(68,98,207,0.06);
border-radius: 20px;
padding-top:53px;
background-image: url(/static/img/yuanxinxxn.png);
background-repeat: no-repeat;
background-position: 0 0;
}
.contact{
  position: relative;
  padding-top: 40px;
  padding-left: 33px;
  padding-right: 33px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.single{
  position: relative;
  float: left;
  margin-left: 45px;
  height: 78px;
  line-height: 78px;
  text-align: left;
}
.xuexi::before{
  position: absolute;
  top: 25px;
  left: -45px;
  content: '';
  width: 28px;
  height: 28px;
  background-image: url(/static/img/time.png);
  background-repeat: no-repeat;
}
.kecc::before{
  position: absolute;
  top: 25px;
  left: -45px;
  content: '';
  width: 28px;
  height: 28px;
  background-image: url(/static/img/course.png);
  background-repeat: no-repeat;
  background-position-x: right;
}
.shuju::before{
  position: absolute;
  top: 25px;
  left: -45px;
  content: '';
  width: 28px;
  height: 28px;
  background-image: url(/static/img/reat.png);
  background-repeat: no-repeat;
}
.time-line::before{
  position: absolute;
  top: 25px;
  left: -45px;
  content: '';
  width: 28px;
  height: 28px;
  background-image: url(/static/img/time.png);
  background-repeat: no-repeat;
  background-size: 28px;
}
.single h5{
  display: inline;
font-size: 20px;
font-family: PingFang SC;
font-weight: bold;
color: #2A2727;
}
.single span{
  display: inline;
font-size: 20px;
font-family: PingFang SC;
font-weight: bold;
color: #999999;
}
</style>